var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Voice',{attrs:{"detail":{
  no: '01',
  belong: 'ＪＲ九州ホテル ブラッサム那覇',
  title: '支配人',
  profile: 'ＪＲ九州ホテル ブラッサム那覇',
  name: '竹村 亜由美',
  date: '２０１１年入社',
  sm: {
    belong: 'ＪＲ九州ホテル ブラッサム那覇',
    name: '支配人',
  },
  intro: 'ホテル業界に魅せられ理想を追求。「感謝」と「笑顔」を忘れずにわたしたちにできる最高のサービスを。',
  content: [
    {
      title: '経験をベースにＪＲ九州ホテルズアンドリゾーツでさらに飛躍',
      text: 'ホテルを題材にしたドラマをきっかけに、この業界に興味を持ちました。実際に働いてみると、最上級のサービスを提供しながら奇跡や感動の場面に出会える日々で、心から魅了されました。10年ほど他社のホテルに勤めた後、2011年にＪＲ九州ホテルズアンドリゾーツに転職しました。最初はＪＲ九州ホテル宮崎の開業に合わせたオープニングメンバーとして配属され、その後マネージャーとして小倉へ異動。約3年半の小倉勤務を経て、ブラッサム那覇の開業に携わりました。ホテルを一から作るという貴重な経験をさせていただきましたし、副支配人という立場となり、現場と支配人のパイプ役となるなど、より責任を持って仕事に取り組むことができました。',
    },
    {
      title: 'コミュニケーションを欠かさず働きやすい職場を意識',
      text: '2021年からは現在のホテル、ブラッサム福岡で支配人を拝命しました。トップとして部下の皆に同じ意識を共有し、組織としての成長を目指しています。責任も増えましたが、仲間と一緒にホテルを盛り上げていく喜びを日々実感しています。私たちの職場で、「コミュニケーション」と「チームワーク」はとても大切な要素です。お客さまに対してはもちろんのこと、スタッフにも常に感謝の気持ちを持って接するよう心がけています。居心地の良い職場環境を作るのは、支配人にとってとても大切な仕事ですから。',
    },
    {
      title: '人こそ会社の宝。良好な人間関係が良い環境を作る',
      text: '宮崎からスタートして、小倉、那覇、大分、福岡と九州各地のホテルに勤務し、弊社の「人の良さ」を改めて実感しています。ホテル現場での些細な問題でも、周りが一緒になって解決してくれます。また現場からの要望はすぐに本社が対応してくれます。私自身も困った時は相談できる上司がいて、常にサポートしてもらえるのはとても安心です。本当に良い会社に入らせていただいたと実感しています。',
    },
    {
      title: 'ホテルは多くの感動が生まれる場所',
      text: '私たちが目指すのは、自分たちにしかできない最高のサービスで、少しでもお客さまに喜んでいただくこと。それがいちばんのやりがいです。スタッフにも、「業界トップクラスの接客」や「接客のスペシャリスト」の意識を持ち、多くの感動をお客さまと作っていってほしいと思います。大好きな現場を大事にしながら、再び新規開業にも関われるよう、これからもチャレンジし続けてまいります。',
    } ],
  career: [
    {
      year: '2011',
      text: 'ＪＲ九州ホテル宮崎にホテルスタッフとして配属',
    },
    {
      year: '2013',
      text: 'ＪＲ九州ホテル小倉にマネージャーとして配属',
    },
    {
      year: '2017',
      text: 'ＪＲ九州ホテル ブラッサム那覇へ開業準備のために異動',
    },
    {
      year: '2018',
      text: '同ホテル副支配人へ昇格',
    },
    {
      year: '2020',
      text: 'ＪＲ九州ホテル ブラッサム大分へ副支配人として配属',
    },
    {
      year: '2021',
      text: 'ＪＲ九州ホテル ブラッサム福岡へ支配人として異動',
    },
    {
      year: '2023',
      text: 'ＪＲ九州ホテルブラッサム那覇へ支配人として異動',
      isLast: true,
    } ],
  message: 'ホテルスタッフに求められるのは、常に笑顔でお客さまと接する姿勢です。<br>弊社は、ふだんから笑顔でいられるほど、温かい雰囲気にあふれています。<br>そして自分のやりたいことを表現しやすい風通しの良さも魅力です。<br>「人を喜ばせたい」という気持ちがあれば大丈夫。<br>私たちと一緒に成長していきましょう！',
  caption: true,
  navi: {
    prev: {
      title: 'ホテルは私らしく成長できる場所。笑顔と明るさ、特技も活かして誰もが楽しい空間を作りたい。',
      path: '07',
    },
    next: {
      title: '１年目から高みを目指してチャレンジの連続。副支配人となった今も日々成長を感じている',
      path: '02',
    },
  },
}}})}
var staticRenderFns = []

export { render, staticRenderFns }